import {createBrowserHistory} from 'history';
import {hasSimproSession} from "../../utils/WindowContextUtils";

export const authorizationResponseInterceptor = (error: any) => {
	const {response} = error;
	if (response?.status === 401) {
		let url = "/error?login";
		if (!hasSimproSession()) {
			url = "/error?cookies";
		}
		createBrowserHistory().push(url);
		window.location.reload();
	}
	return Promise.reject(error)
}